module.exports = __webpack_public_path__ + "img/AboutExport2.88151be3.png";